import { Box, styled } from "@mui/material";
import { Button, Typography } from "@pmag/ui-components";

export const BoxStyled = styled(Box)(({ theme }) => ({
    color: theme.palette.core.grey._60,

    "&:last-of-type": {
        color: theme.palette.core.grey._80,
        ":hover": {
            borderColor: theme.palette.core.grey._80,
            cursor: "pointer",
        },
    },

    span: {
        display: "block",
        width: "100%",
        color: "inherit",
        textDecoration: "none",
        borderBottom: "1px solid",
        borderColor: theme.palette.core.transparent,

        ":hover": {
            borderColor: theme.palette.core.grey._60,
            cursor: "pointer",
        },
        ":focus-visible": {
            color: theme.palette.blue._50,
            outline: "none",
            ":hover": {
                borderColor: theme.palette.blue._50,
                cursor: "pointer",
            },
        },
    },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    padding: `${theme.spacing(2)} 0`,
    minWidth: "unset",
    color: "inherit",
}));

export const BreadcrumbTypography = styled(Typography)({
    whiteSpace: "nowrap",
    width: "100%",
    display: "block",

    "&, & span": {
        maxWidth: "220px",
        textOverflow: "ellipsis",
        overflowX: "hidden",
    },
});
